import { render, staticRenderFns } from "./ScannedAssetsView.vue?vue&type=template&id=f06cd5fe&scoped=true"
import script from "./ScannedAssetsView.vue?vue&type=script&lang=js"
export * from "./ScannedAssetsView.vue?vue&type=script&lang=js"
import style0 from "./ScannedAssetsView.vue?vue&type=style&index=0&id=f06cd5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06cd5fe",
  null
  
)

export default component.exports